import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { HeaderDistruzioneOperazioniMassive, HeaderDistruzioneOperazioniMassiveForm } from '../models/operazioni-massive.model';


@Component({
  selector: 'app-intestazione-distruzione',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
      <form [formGroup]="headerForm">
        <div class="advanced-form">
          <div class="grid">
            <div class="col-12">
              <label class="small-label" for="ordineServizio">Numero ordine di servizio</label>
              <p-inputNumber id="ordineServizio" formControlName="ordineServizio" mode="decimal" [useGrouping]="false" [style]="{'width': '420px'}"/>
            </div>

            <div class="col-12 lg:col-6">
              <label class="small-label" for="mezzoDistruzione">Mezzo</label>
              <p-dropdown inputId="mezzoDistruzione" formControlName="mezzoDistruzione"  [options]="mezzoDistruzioneValues" placeholder="Seleziona il mezzo di distruzione" [style]="{'width': '420px'}" />
            </div>

            <div class="col-12 lg:col-6">
              <label class="small-label" for="dataDistruzione">Data distruzione</label>
              <p-calendar formControlName="dataDistruzione" inputId="dataDocumento"
                dateFormat="dd/mm/yy" selectionMode="single" [showIcon]="true" [inputStyle]="{'width': '420px'}">
              </p-calendar>
            </div>

            <div class="col-12 lg:col-6 mt-4">
              <span class="small-label" for="salvaSuRegistro">Compilare il verbale di Distruzione?</span>
              <!-- <p-checkbox formControlName="salvaSuRegistro" [binary]="true" inputId="salvaSuRegistro"/> -->
              <!-- <p-toggleButton formControlName="salvaSuRegistro"  onLabel="Compilare il verbale di Distruzione"  offLabel="Non compilare il verbale di Distruzione" inputId="salvaSuRegistro" /> -->

              <p-selectButton  [options]="stateOptions" formControlName="salvaSuRegistro"  optionLabel="label" optionValue="value" inputId="salvaSuRegistro"/>
            </div>            
          </div>
        </div>
      </form>
      `
})
export class IntestazioneDistruzioneComponent {

  onCompiled = output<HeaderDistruzioneOperazioniMassive | undefined>();

  private readonly fb = inject(FormBuilder);
  public headerForm: FormGroup<HeaderDistruzioneOperazioniMassiveForm>;

  public mezzoDistruzioneValues: string[] = ['Fuoco', 'Macchina Tritacarte', 'Macchina Polpatrice'];

  public stateOptions: any[] = [
    { label: 'Si', value: true },
    { label: 'No', value: false }
  ];

  constructor() {
    this.headerForm = this.fb.group<HeaderDistruzioneOperazioniMassiveForm>(
      {
        ordineServizio: new FormControl(null),
        dataDistruzione: new FormControl(null),
        mezzoDistruzione: new FormControl(''),
        salvaSuRegistro: new FormControl(true, [Validators.required])
      },
      { validators: distruzioneHeaderValidator }
    );

    this.headerForm.valueChanges.subscribe(d => {

      let value: HeaderDistruzioneOperazioniMassive | undefined = undefined;

      if (this.headerForm.valid) {
          value = {
            ordine: this.headerForm.value.ordineServizio??"",
            dataDistruzione: this.headerForm.value.dataDistruzione??null,
            mezzoDistruzione: this.headerForm.value.mezzoDistruzione??"",
            salvaSuRegistro: !!this.headerForm.value.salvaSuRegistro
          };
      }

      this.onCompiled.emit(value);
    });
  }
}

export const distruzioneHeaderValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const salvaSuRegistro : boolean = !!group.get('salvaSuRegistro')?.value;
    const mezzoDistruzione : string | null = group.get('mezzoDistruzione')?.value;
    const dataDistruzione : Date | null = group.get('dataDistruzione')?.value;
    const ordineServizio : string | null = group.get('ordineServizio')?.value;

    return (salvaSuRegistro && !!mezzoDistruzione && dataDistruzione && ordineServizio) || (!salvaSuRegistro) ? null : { fieldRequired: true };
};
  